import { render, staticRenderFns } from "./character.vue?vue&type=template&id=f939cbbc&scoped=true&"
import script from "./character.vue?vue&type=script&lang=js&"
export * from "./character.vue?vue&type=script&lang=js&"
import style0 from "./character.vue?vue&type=style&index=0&id=f939cbbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f939cbbc",
  null
  
)

export default component.exports